import React from "react";
import Template from "../../templates/Owner/Owner";

const Owner = (): React.ReactElement => {
  return <Template />;
};

export default Owner;
